import { type Locale } from 'models/locale';
import { z } from 'zod';

export const promoBannerUrlSchema = z.string().url().max(500);

export const optionalPromoBannerUrlSchema = z
    .string()
    .max(500)
    .refine((value) => value === '' || promoBannerUrlSchema.safeParse(value).success, {
        message: 'Invalid URL',
    })
    .default('');

export function getLocalizedPromoBannerUrl(locale: Locale, linkUrl: string, linkUrlFr: string): string {
    const url = locale === 'fr-CA' && linkUrlFr ? linkUrlFr : linkUrl;
    return sanitizePromoBannerUrl(url);
}

const SAFE_URL_PROTOCOLS = new Set(['http:', 'https:', 'mailto:']);

/**
 * Ensures a URL only uses a safe protocol before it is used as an href, preventing
 * `javascript:`/`data:` based XSS. Returns '#' for any unsafe or unparseable value.
 */
export function sanitizePromoBannerUrl(url: string): string {
    try {
        const parsed = new URL(url);
        return SAFE_URL_PROTOCOLS.has(parsed.protocol) ? url : '#';
    } catch {
        return '#';
    }
}
